var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{attrs:{"src":"https://ljtc.tcrc.com.cn/webroot/decision/view/report?viewlet=tcrc%252F%25E5%25B8%2582%25E5%259C%25BA%25E4%25BF%25A1%25E6%2581%25AF%25E7%25BB%259F%25E8%25AE%25A1.cpt&ref_t=design&ref_c=fb0f47a6-4993-47f2-84e3-b50fdf44ba77","id":"mobsf","width":"100%","height":"100%","scrolling":"no","frameborder":"0"}})
}
var staticRenderFns = []

export { render, staticRenderFns }